import React from "react";
import { Link } from "react-router-dom";
import footerMap from "../../images/footer-map.png";
import DynamicImage from "../common/DynamicImage";

const socialIconMap = {
  facebook: "bx bxl-facebook",
  twitter: "bx bxl-twitter",
  instagram: "bx bxl-instagram",
  linkedin: "bx bxl-linkedin",
};
const BaseUrl = process.env.REACT_APP_UPLOAD_URL;
const Footer = ({ data }) => {
  if (!data) return null;
  const currentYear = new Date().getFullYear();

  const {
    companyName,
    logo,
    footer,
    address,
    phone_number,
    email,
    socialLinks = [],
    companyInfo = [],
  } = data;

  return (
    <footer className="footer-area bg-color">
      <div className="container">
        <div className="row gy-4">
          {/* Logo + Description */}
          <div className="col-lg-4 col-sm-6">
            <div className="single-footer-widget">
              {logo && (
                <Link to="/" className="logo">
                  <img src={`${BaseUrl}${logo?.url}`} alt="logo" />
                </Link>
              )}

              {footer?.description && <p>{footer?.description}</p>}

              <ul className="social-link">
                {socialLinks.map((item, i) => {
                  const iconClass = socialIconMap[item.platform?.toLowerCase()];
                  return (
                    <li key={i}>
                      <Link
                        to={item.url}
                        className="d-block"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {item.icon ? (
                          <DynamicImage image={item.icon} alt={item.platform} />
                        ) : (
                          <i className={iconClass}></i>
                        )}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>

          {/* Quick Links */}
          {footer?.menus && footer?.menus.length > 0 && (
            <div className="col-lg-2 col-sm-6">
              <div className="single-footer-widget pl-5">
                <h3>Quick Links</h3>
                <ul className="footer-links-list">
                  {/* {footer?.menus?.map((menu, i) => (
                    <li key={i}>
                      <Link to={menu.url}>{menu.label}</Link>
                    </li>
                  ))} */}
                  {footer?.menus?.map((menu, i) => {
                    const quickLink = menu?.quick_links?.[0];

                    const parentSlug = quickLink?.parent?.slug;
                    const pageSlug = quickLink?.page?.slug;
                    const url = quickLink?.url;

                    let link = "#";

                    if (parentSlug && pageSlug) {
                      link = `/${parentSlug}/${pageSlug}`;
                    } else if (pageSlug) {
                      link = `/${pageSlug}`;
                    } else if (url) {
                      link = url;
                    }

                    return (
                      <li key={i}>
                        <Link to={link}>{menu.label}</Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          )}

          {/* Services */}
          {footer?.servicesMenu && footer?.servicesMenu.length > 0 && (
            <div className="col-lg-2 col-sm-6">
              <div className="single-footer-widget">
                <h3>Our Services</h3>
                <ul className="footer-links-list">
                  {footer?.servicesMenu?.map((service, i) => {
                    const menu = service?.service_menus?.[0];

                    const parentSlug = menu?.parent?.slug;
                    const pageSlug = menu?.page?.slug;

                    const link =
                      parentSlug && pageSlug
                        ? `/${parentSlug}/${pageSlug}`
                        : `/${service.url}`;

                    return (
                      <li key={i}>
                        <Link to={link}>{service.label}</Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          )}

          {/* Address */}
          {/* {companyInfo && companyInfo.length > 0 && (
          <div className="col-lg-4 col-sm-6">
            <div className="single-footer-widget">
              <h3>Address</h3>

              <ul className="footer-contact-info">
                {companyInfo.map((info, i) => (
                  <li key={i}>
                    {info.infoTitle === "Address" && <i className="bx bx-map"></i>}
                    {info.infoTitle === "Phone number" && <i className="bx bx-phone-call"></i>}
                    {info.infoTitle === "Email" && <i className="bx bx-envelope"></i>}

                    {info.infoTitle === "Phone number" ? (
                      <a href={`tel:${info.infoText}`}>{info.infoText}</a>
                    ) : info.infoTitle === "Email" ? (
                      <a href={`mailto:${info.infoText}`}>{info.infoText}</a>
                    ) : (
                      info.infoText
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          )} */}
          {companyInfo && companyInfo.length > 0 && (
            <div className="col-lg-4 col-sm-6">
              <div className="single-footer-widget">
                <h3>Contact Us</h3>

                {/* <ul className="footer-contact-info">
                  {companyInfo.map((info, i) => {
                    const iconMap = {
                      Address: "bx bx-map",
                      "Phone number": "bx bx-phone-call",
                      Email: "bx bx-envelope",
                    };

                    const iconClass =
                      iconMap[info.infoTitle] || "bx bx-info-circle"; // ✅ default icon

                    return (
                      <li key={i}>
                        <i className={iconClass}></i>

                        {info.infoTitle === "Phone number" ? (
                          <a href={`tel:${info.infoText}`}>{info.infoText}</a>
                        ) : info.infoTitle === "Email" ? (
                          <a href={`mailto:${info.infoText}`}>
                            {info.infoText}
                          </a>
                        ) : (
                          info.infoText
                        )}
                      </li>
                    );
                  })}
                </ul> */}

                <ul className="footer-contact-info">
                  <li>
                    <i className="bx bx-map"></i>
                    {address}
                  </li>
                  <li>
                    <i className="bx bx-phone-call"></i>
                    <Link to={`tel:${phone_number}`}>{phone_number}</Link>
                  </li>
                  <li>
                    <i className="bx bx-envelope"></i>
                    <Link to={`mailto:${email}`}>{email}</Link>
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>

        {/* Bottom */}
        <div className="footer-bottom-area">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6">
              <p>
                © {currentYear}{" "}
                <Link to="/" className="fw-bold">
                  {companyName || "Cyblox"}
                </Link>{" "}
                All rights reserved.{""}
                {footer?.copyright && <> {footer?.copyright}</>}
              </p>
            </div>
            <div className="col-lg-6 col-md-6">
              <ul>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms-and-conditions">Terms & Conditions</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Map Image */}
      <div className="footer-map">
        <img src={footerMap} alt="map" />
      </div>
    </footer>
  );
};

export default Footer;
